import { render, staticRenderFns } from "./SingleVacancyDisplay.vue?vue&type=template&id=6491c87d&"
import script from "./SingleVacancyDisplay.vue?vue&type=script&lang=js&"
export * from "./SingleVacancyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports